<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import 'map'

    .page-type-contact
        [role="contentinfo"],
        .form-actions.js-form-wrapper.form-wrapper
            // display: none

    .node-contact
        .block-breadcrumb
            padding-top: 6rem
            +media("<=1000px")
                padding-top: 4rem

        &__section
            padding: 45px 30px
            +media("<tablet")
                padding: 30px 10px

            &--border
                .container
                    border-top: 1px solid $color-gray-medium
                    padding-top: 45px
                    +media("<tablet")
                        padding-top: 2rem
            &--gray
                background-color: $color-gray-light

                .node-contact__section + .node-contact__section
                    padding-top: 0

            &--message + &--contact
                padding-top: 0

            &--mutuelle
                .InputRadioButton .el-radio-button
                flex-basis: calc(50% - 2rem)
                span
                    height: 100%
                    display: flex
                    align-items: center
                    justify-content: center

            .node-contact__title:not(:first-child)
                margin-top: 5rem
                +media("<tablet")
                    margin-top: 2.5rem

            .title--2
                margin-bottom: 1.875rem
                font-size: 27px

        &__options
            .InputRadioIcons
                .el-radio-group
                    flex-flow: row wrap
                    +media("<1024px")
                        flex-flow: column wrap

                    .InputRadioIcons__item
                        flex-basis: calc(20% - 26.5px)
                        min-height: 175px
                        margin: 0 0 30px 30px
                        +media("<1024px")
                            min-height: auto
                            margin: 0 0 20px

                        &:nth-child(5n +1)
                            margin-left: 0


        &__info
            padding: 2.8125rem 6rem
            border-top: 10px solid $color-green
            box-shadow: 5px 5px 30px 0 rgba(129, 129, 129, 0.3)
            text-align: center
            background-color: $color-white
            +media("<1024px")
                padding: 2.8125rem 3rem
            +media("<768px")
                padding: 1.875rem 1.25rem

            &.border--red
                border-top: 10px solid $color-base2

            &.border--orange
                border-top: 10px solid $color-orange

            &.border-top
                margin-top: 40px

            .info--wrapper
                max-width: 730px
                margin: auto

            .info-title
                font-family: Montserrat, sans-serif
                font-size: 18px
                font-weight: 700
                line-height: 27px
                margin-bottom: 1.875rem
                +media("<768px")
                    margin-bottom: 1.25rem

            svg
                width: 5rem
                height: 5rem
                margin-bottom: 1rem

            .actions
                display: flex
                justify-content: center
                align-items: center
                margin-top: 2.25rem
                margin-bottom: 1.875rem
                +media("<768px")
                    margin-top: 1.25rem
                    flex-flow: column nowrap
                &.mb-0
                    margin-bottom: 0

                .button
                    padding: 1rem 40px
                    &:focus
                        position: relative
                        &:before
                            content: ''
                            position: absolute
                            top: 0
                            left: 0
                            width: 100%
                            height: 100%
                            box-shadow: 0 0 2px 2px #409EFF

                    +media("<768px")
                        width: 100%

                a
                    width: auto
                    margin: 0
                    +media("<1024px")
                        margin: auto
                    +media("<768px")
                        margin: 1rem

                a + a
                    margin-left: 1.5625rem

        &__info--xl
            display: flex
            justify-content: flex-start
            align-items: center
            text-align: left
            +media("<1024px")
                flex-flow: column nowrap

            img
                margin-right: 6rem
                +media("<1024px")
                    margin-right: 0
                    margin-bottom: 20px
                +media("<768px")
                    width: 100%

            .actions
                justify-content: flex-start
                margin-bottom: 0

        &__validation
            margin-top: -20px
            padding: 0 30px 45px
            +media("<tablet")
                margin-top: 0
                padding: 0 10px 20px

            .button--red
                margin-top: 30px !important

            .link
                &:focus,
                &:hover
                    text-decoration: underline

            .text.legals
                font-size: 14px

        &__confirmation
            padding: 95px 30px
            text-align: center
            +media("<1024px")
                padding: 45px 30px

            &.big-pt
                padding: 160px 30px 95px 30px
                +media("<1024px")
                    padding: 110px 30px 45px 30px

            .title--2
                margin-bottom: 45px

            .node-legal__content
                margin-top: 0

        &__title
            font-family: Montserrat, sans-serif
            font-size: 18px
            font-weight: 700
            line-height: 27px
            color: $color-text
            margin-top: 0
            margin-bottom: 1.5625rem
            +media("<768px")
                margin-bottom: 1.25rem

        &__wrapper
            max-width: 600px
            margin: 0

        &__captcha
            margin-top: 0
            > div
                margin: 0
            &__error
                color: $color-base
                font-size: 14px
                margin: 0.25rem 0 0

        &__field
            + .node-contact__field
                margin-top: 30px

            &.small
                max-width: 200px

                .Input__error,
                small
                    white-space: nowrap

            label
                position: relative
                display: block
                margin-bottom: 10px
                line-height: 1

                .optional
                    position: absolute
                    top: 0
                    right: 0
                    font-size: 0.875rem
                    color: $color-gray-dark

        .Input
            &__error
                font-family: Roboto, sans-serif
                font-size: 14px
                font-weight: 400
                margin-top: 0.25rem
                color: $color-base


            .el-input__inner,
            .el-select .el-input__inner
                padding: 8px 16px

            .el-input__inner,
            .el-textarea__inner,
            .el-select .el-input__inner
                border-radius: 2px
                border: 1px solid $color-gray-dark
                background-color: $color-white

            .el-radio-group[name="input-effectif"] label
                min-width: 20rem

        .Input.InputUpload
            margin: 0
            background: transparent

        small
            display: block
            margin: 10px 0 0
            font-size: 14px
            line-height: 21px
            color: $color-gray-dark
            a
                text-decoration: underline

        .button--red
            padding: 1rem 1.5rem
            margin: 0 0 20px
            width: auto
            max-width: 24rem
            display: block

        .button--send
            display: inline-flex
            justify-content: center
            align-items: center
            +media("<tablet")
                width: 100%
                max-width: none

            .button-text-sended
                display: none

            &:hover
                .loader
                    &:after
                        background: darken($color-base, 5)

            &.is-loading
                svg
                    display: none
                .loader
                    display: block

            &.sended
                background: $color-green-light

                .svg-arrow,
                .loader,
                .button-text
                    display: none
                .svg-send,
                .button-text-sended
                    display: block

            svg
                height: 30px
                width: 30px
                margin-right: 15px
                fill: white

                &.svg-send
                    display: none

            .loader
                display: none
                font-size: 10px
                margin-right: 15px
                text-indent: -9999em
                width: 30px
                height: 30px
                border-radius: 50%
                background: $color-white
                background: linear-gradient(to right, $color-white 10%, rgba(255, 255, 255, 0) 42%)
                position: relative
                animation: load3 1.4s infinite linear
                transform: translateZ(0)

                &:before
                    content: ''
                    position: absolute
                    top: 0
                    left: 0
                    width: 50%
                    height: 50%
                    border-radius: 100% 0 0 0
                    background: $color-white

                &:after
                    content: ''
                    position: absolute
                    top: 0
                    left: 0
                    bottom: 0
                    right: 0
                    width: 90%
                    height: 90%
                    margin: auto
                    border-radius: 50%
                    background: $color-base
                    transition: background 0.3s ease

        .tooltip
            position: relative
            display: inline-block
            vertical-align: bottom
            width: 16px
            height: 16px
            margin-left: 5px

            &:hover
                .tooltiptext
                    opacity: 1
                    visibility: visible

            .tooltiptext
                position: absolute
                top: 8px
                left: calc(100% + 15px)
                z-index: 1
                width: 300px
                padding: 10px 20px
                font-size: 14px
                line-height: 1.6
                text-align: left
                opacity: 0
                visibility: hidden
                color: $color-gray-dark
                background-color: $color-white
                box-shadow: 0 0 15px 0 rgba(129, 129, 129, 0.6)
                transform: translateY(-50%)
                transition: opacity 1s ease
                +media("<768px")
                    width: 190px

                .bold
                    font-weight: 700

                &:after
                    content: ""
                    position: absolute
                    top: 50%
                    right: 100%
                    margin-top: -10px
                    border-width: 10px
                    border-style: solid
                    border-color: transparent $color-white transparent transparent

            &.-forradio
                +media("<1024px")
                    display: none

                .tooltiptext
                    +media("<768px")
                        left: auto
                        right: calc(100% + 15px)

                    &:after
                        +media("<768px")
                            right: auto
                            left: 100%
                            border-color: transparent transparent transparent $color-white

        .actus
            max-width: none
            padding: 0
            text-align: left

            &__items
                margin-top: 0

            &__item
                &__tag
                    color: $color-base

    @-webkit-keyframes load3
      0%
          transform: rotate(0deg)
      100%
          transform: rotate(360deg)

    @keyframes load3
      0%
          transform: rotate(0deg)
      100%
          transform: rotate(360deg)


    .prevent-ie
        display: flex
        justify-content: center
        align-items: center
        width: 100%
        min-height: 100vh

        .container
            text-align: center
            margin: 0
            padding: 30px 0

            +media("<1024px")
                width: 80%
            +media("<768px")
                width: 90%

        &__logo
            margin: 0 auto 30px

        &__title
            font-family: Montserrat, sans-serif
            font-size: 40px
            line-height: 40px
            margin: 10px auto 40px
            font-weight: 800
            color: $color-base2
            +media("<768px")
                font-size: 24px
                line-height: 24px
                margin: 10px auto 30px

        &__text
            font-family: Montserrat, sans-serif
            font-size: 27px
            line-height: 30px
            margin: 0 auto 40px
            +media("<768px")
                font-size: 14px
                line-height: 14px
                margin: 10px auto 30px

            &.bold
                font-weight: 700

        &__browsers
            display: flex
            flex-flow: row nowrap
            justify-content: space-around
            align-items: center
            font-family: Montserrat, sans-serif
            font-size: 27px
            line-height: 30px
            margin: 0 auto 60px
            +media("<768px")
                font-size: 14px
                line-height: 14px
                margin: 10px auto 40px

            .link
                display: inline-flex
                flex-flow: column nowrap
                justify-content: center
                align-items: center
                cursor: pointer

            img
                width: 80px
                margin: 0
                +media("<768px")
                    width: 40px

        .link
            &:focus,
            &:hover
                text-decoration: underline

</style>

<script>
    import $ from "jquery";
    import { each, compact, map } from "lodash/core";
    import moment from "moment";
    import {data, objetDuMessageData, objetDuMessageAutreData, modeDeContactData, momentDeContactData, typeDeSocieteData, objetDuMessageSanteData, objetDuMessageSante2Data, secteurActiviteData, chiffreAffaireData, effectifData, departementData} from "./data.js";

    import InputRadioIcon from "./components/InputRadioIcon.vue";
    import InputRadioButton from "./components/InputRadioButton.vue";
    import InputSelect from "./components/InputSelect.vue";
    import InputText from "./components/InputText.vue";
    import InputTextArea from "./components/InputTextArea.vue";
    import InputCheckbox from "./components/InputCheckbox.vue";
    import InputUpload from "./components/InputUpload.vue";
    import InputAutocomplete from "./components/InputAutocomplete.vue";

    const formIds = {
        "La mutuelle de Verspieren": "contact-sante",
        "Une assurance pour particulier": "contact-client",
        "Une assurance pour professionnel ou entreprise": "contact-prospect",
        "Professionnel : une demande sur un de nos assurés": "contact-professionnel",
    };

    export default {

        components: {
            InputRadioButton,
            InputRadioIcon,
            InputText,
            InputTextArea,
            InputSelect,
            InputCheckbox,
            InputUpload,
            InputAutocomplete
        },

        data() {
            return {
                items: data,
                objetDuMessageItems: objetDuMessageData,
                objetDuMessageAutreItems: objetDuMessageAutreData,
                objetDuMessageSanteItems: objetDuMessageSanteData,
                objetDuMessageSante2Items: objetDuMessageSante2Data,
                modeDeContactItems: modeDeContactData,
                momentDeContactItems: momentDeContactData,
                typeDeSocieteItems: typeDeSocieteData,
                secteurActiviteItems: secteurActiviteData,
                isPosted: false,
                postDataFirstCall: false,
                chiffreAffaireItems: chiffreAffaireData,
                effectifItems: effectifData,
                departementItems: departementData,
                form: {
                    typeUtilisateur1: "", // Je suis
                    typeDeRequete: "", // Je souhaite
                    typeUtilisateur2: "", // Pro ou Part
                    typeDeContrat: "",  // Type de contrat
                    typeDeContratDetail: "",  // Type de contrat Detail
                    chiffreaffaire: "",  // Chiffre Affaire
                    effectif: "",  // Effectif

                    /* Common */
                    nom: "",
                    prenom: "",
                    firstnamelastname: "",
                    numeroContrat: "",
                    contrat: "",
                    societe: "",
                    siret: "",
                    objetDuMessage: "",
                    message: "",
                    modeDeContact: "",
                    momentDeContact: "",
                    email: "",
                    telephone: "",
                    typeDeSociete: "",
                    fonction: "",
                    secteurActivite: "",
                    departement: "",
                    numeroSecuriteSociale: "",
                    optin: "",
                    optinDate: "",
                    optinEmail: "",
                    document: "",
                    finess: "",

                    // Captcha
                    captcha: ""
                },
                rules: {
                    typeUtilisateur2: ["required"],
                    typeDeRequete: ["required"],
                    typeDeContrat: ["required"],
                    typeDeContratDetail: ["required"],
                    nom: ["required", "name"],
                    prenom: ["required", "name"],
                    firstnamelastname: ["firstnamelastname"],
                    numeroContrat: ["required"],
                    contrat: ["required"],
                    societe: ["raisonsociale"],
                    siret: ["numsiret"],
                    objetDuMessage: ["required"],
                    message: ["message"],
                    modeDeContact: ["required"],
                    momentDeContact: ["required"],
                    email: ["email"],
                    telephone: ["telephone"],
                    typeDeSociete: ["required"],
                    fonction: ["required"],
                    secteurActivite: ["secteur"],
                    numeroSecuriteSociale: ["required", "number", "numsecu"],
                    captcha: ["captcha"],
                    chiffreaffaire: ["ca"],
                    effectif: ["effectif"],
                    finess: ["finess"],
                    departement: ["departement"],
                    optin: ["optin"]
                },
                errors: {},
                recaptcha: {
                    // key: "6LcnZEwUAAAAAKLcrlb5xBlQtLk8XxoSO7HPwdFt" // Prod
                    // key: "6LffrkwUAAAAAEMJyemohkcxb4iy6RwsYbllivwW" // Local debug
                    // key: '6LenR2oUAAAAAGFoCwZ5pDTO-q1J-7WMR_AtJEV2', // Dev
                    //key: '6LfcqcUZAAAAADLqsMiRrnXWjB3pmiTCIgNdp6IN', // Dev
                    //key: '6LeCrMcZAAAAAF2PLzgtg31zu1tk-g7ql0tl-CCI', // Dev
                    key: '6Lc_PNcZAAAAAM9eEpD-cqUea-y7E353UdQLz5DR', // Dev
                }
            }

        },


        watch: {
            "form.typeUtilisateur1": function () {
                this._resetForm()
            },
            "form.typeDeRequete": function () {
                this._resetFormTypeDeRequete()
            },
        },

        mounted() {
            this.isPosted = $('.webform-confirmation').length !== 0

            // this.isIE = (window.navigator.userAgent.indexOf("MSIE ")> 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));

            // focus sur le premier parcours au chargement de la page
            $($('.el-radio-button')[0]).focus()
        },

        methods: {
            scrollTo(query) {
                setTimeout(() => {
                    if ($(query).length ) {
                        $(query).removeAttr('style');
                        $("html, body").animate({
                            scrollTop: $(query).position().top - 100
                        }, 900);

                        // focus sur le premier...
                        if ($(query).find('.node-contact__info').length) {
                            // ... button d'un bloc d'information
                            $($(query).find('.node-contact__info').find('a.button')[0]).focus();
                        } else if ($(query).find('.node-contact__field').length) {
                            // ... input d'un formulaire
                            $($(query).find('.node-contact__field')[0]).find('input').focus();
                            $('.node-contact__validation').removeAttr('style');

                            // Press the enter button inside the form
                            var that = this;
                            $(query).off('keydown');
                            $(query).on('keydown', function(e) {
                                if(e.keyCode == 13){
                                    // Check if we are not inside the select "secteurActivite" or "departement"
                                    if ($(e.target).attr('name') !== "input-secteurActivite" ||
                                      $(e.target).attr('name') !== "input-departement") {
                                      if ($(e.target).prop("tagName") !== "TEXTAREA") {
                                        e.preventDefault();
                                        $(query).next('.node-contact__validation').find('a.button').focus();
                                        that.postData();
                                      }
                                    }
                                }
                            });
                            // Press the enter button when the button 'Send' has the focus
                            $('.node-contact__validation').on('keydown', function(e) {
                                if(e.keyCode == 13){
                                    e.preventDefault();
                                    $('.node-contact__validation').find('a.button').focus();
                                    that.postData();
                                }
                            });

                        } else {
                            // ... bloc d'une sous-catégorie
                            $($(query).find('.el-radio-button')[0]).focus();
                            if (query === '.level1' && $(query).find('.el-radio-button').length > 8) {
                                $(query).find('.js-see-more').show();
                            } else {
                                $(query).find('.js-see-more').hide();
                            }
                        }

                        // Reset les tabindex
                        $('.el-radio-button[tabindex="-1"]').attr('tabindex', 0)
                    }
                }, 100);
            },

            onContractChange: function () {
                this.form.typeDeContratDetail = null
            },
            postData: function () {
                this.postDataFirstCall = true;
                this.form.captcha = window.grecaptcha.getResponse();
                if (this.form.optin) {
                    this.form.optinDate = moment().format("LLL")
                }
                this.fillForms();
                if (this.validate() && this.form.captcha.length > 0) {
                    this.sendForm();
                } else {
                    setTimeout(() => {
                      $("html, body").animate({
                         scrollTop: $($('.Input__error')[0]).closest('.node-contact__field').offset().top - 150
                      }, 900);
                      $($('.Input__error')[0]).closest('.node-contact__field').find('input').focus();
                    }, 500);
                }
            },
            fillForms() {
                each(this.form, (value, key) => {
                    const $input = this._getFormInput(key);
                    if ($input.length) {
                        $input.val(value);
                    }
                });
            },
            sendForm() {
                $('.button--send').addClass('is-loading');
                const $form = this._getForm(formIds[this.form.typeUtilisateur1]);
                if ($form.length) {
                    // TODO change id #edit-submit--2 #edit-submit--3 #edit-submit--4
                    setTimeout(() => {
                      $('.button--send').removeClass('is-loading').addClass('sended');
                      $form.find("[type='submit'][id*='edit-submit']").trigger("click");
                    }, 1500);
                }
            },
            backToForm() {
                // TODO
                // $(this.$el).find("form").submit();
            },
            validate() {
                if (this.postDataFirstCall === false) {
                    return;
                }
                this.errors = {};
                let isValid = true;
                each(this.rules, (item, name) => {
                    if ( !this.validateField(name) ) {
                        isValid = false;
                    }
                });
                return isValid;
            },
            validateField(name) {
                const tests = this.rules[name];
                if (tests && $(this.$el).find(`[name='input-${name}']`).length) {
                    let errors = compact(map(tests, (test) => {
                        switch (test) {
                                case "required": {
                                    return !this.form[name] ? "Ce champ est obligatoire" : null;
                                }
                                case "alpha": {
                                    return !this.form[name] || !this._validateAlpha(this.form[name]) ? "Ce champ ne peut contenir que des lettres" : null;
                                }
                                case "name": {
                                    return !this.form[name] || !this._validateName(this.form[name]) ? "Ce champ ne peut contenir que des lettres, des tirets ou des apostrophes" : null;
                                }
                                case "firstnamelastname": {
                                    if (!this.form[name] || this.form[name].length == 0) {
                                      return "Veuillez saisir votre prénom et votre nom.";
                                    } else if (!this.form[name] || !this._validateName(this.form[name])) {
                                        return "Votre prénom et votre nom ne peuvent contenir que des lettres.";
                                    } else if ((this.form[name].split(" ").length === 1 || (this.form[name].split(" ").length > 1 && this.form[name].split(" ")[0].length === 0)) && (!this.form[name] || !this._validateLastnameFirstname(this.form[name]))) {
                                        return "Veuillez saisir votre prénom et votre nom.";
                                    } else if (this.form[name].split(" ").length > 1 && (!this.form[name] || !this._validateLastnameFirstname(this.form[name]))) {
                                        return "Votre nom et votre prénom doivent contenir au minimum 2 cacactères chacun.";
                                    } else {
                                        return null;
                                    }
                                }
                                case "number": {
                                    return !this.form[name] || !this._validateNumber(this.form[name]) ? "Ce champ ne peut contenir que des chiffres" : null;
                                }
                                case "telephone": {
                                  if (jQuery('input[name="input-'+name+'"]').closest('.optionel').length) {
                                      if (this.form[name].length > 0 && (!this.form[name] || !this._validatePhoneNumber(this.form[name]))) {
                                          return "Votre numéro de téléphone doit contenir 10 chiffres.";
                                      } else {
                                          return null;
                                      }
                                  } else {
                                      if (!this.form[name] || this.form[name].length == 0) {
                                          return "Veuillez saisir votre numéro de téléphone.";
                                      } else if (!this.form[name] || !this._validatePhoneNumber(this.form[name])) {
                                          return "Votre numéro de téléphone doit contenir 10 chiffres.";
                                      } else {
                                          return null;
                                      }
                                  }
                                }
                                case "codepostal": {
                                    if (!this.form[name] || this.form[name].length == 0) {
                                        return "Veuillez saisir votre code postal.";
                                    } else if (!this.form[name] || !this._validateZipcode(this.form[name])) {
                                        return "Votre code postal doit comporter 5 chiffres (exemple : 59290).";
                                    } else {
                                        return null;
                                    }
                                }
                                case "email": {
                                    if (!this.form[name] || this.form[name].length == 0) {
                                        return "Veuillez saisir votre adresse e-mail.";
                                    } else if (!this.form[name] || this.form[name].length < 6) {
                                        return "Veuillez saisir votre e-mail au format exemple@domaine.com";
                                    } else if (!this.form[name] || !this._validateEmail(this.form[name])) {
                                        return "Veuillez saisir votre e-mail au format exemple@domaine.com";
                                    } else {
                                        return null;
                                    }
                                }
                                case "numsecu": {
                                    return !this.form[name] || this.form[name].length < 13 ? "Ce champ doit contenir 13 caractères" : null;
                                }
                                case "numsiret": {
                                  if (jQuery('input[name="input-'+name+'"]').closest('.optionel').length) {
                                      if (this.form[name].length > 0 && (!this.form[name] || !this._validateSiret(this.form[name]))) {
                                          return "Votre SIRET doit comporter 14 chiffres.";
                                      } else {
                                          return null;
                                      }
                                  } else {
                                      if (!this.form[name] || this.form[name].length == 0) {
                                          return "Veuillez saisir votre numéro SIRET.";
                                      } else if (!this.form[name] || !this._validateSiret(this.form[name])) {
                                          return "Votre SIRET doit comporter 14 chiffres.";
                                      } else {
                                          return null;
                                      }
                                  }
                                }
                                case "raisonsociale": {
                                    if (!jQuery('input[name="input-'+name+'"]').closest('.optionel').length) {
                                        return !this.form[name] || this.form[name].length < 1 ? "Veuillez saisir votre raison sociale." : null;
                                    } else {
                                        return null;
                                    }
                                }
                                case "secteur": {
                                    return !this.form[name] ? "Veuillez sélectionner votre secteur d’activité dans la liste." : null;
                                }
                                case "ca": {
                                    return !this.form[name] ? "Veuillez sélectionner la tranche de votre chiffre d’affaires." : null;
                                }
                                case "effectif": {
                                    return !this.form[name] ? "Veuillez sélectionner la tranche de votre effectif." : null;
                                }
                                case "message": {
                                    return !this.form[name] ? "Veuillez préciser votre demande." : null;
                                }
                                case "optin": {
                                    return !this.form[name] ? "Veuillez autoriser l’utilisation des informations saisies." : null;
                                }
                                case "finess": {
                                    if (!this.form[name] || this.form[name].length == 0) {
                                        return "Veuillez saisir votre numéro FINESS.";
                                    } else if (!this.form[name] || !this._validateFiness(this.form[name])) {
                                        return "Votre FINESS doit comporter 9 chiffres.";
                                    } else {
                                        return null;
                                    }
                                }
                                case "captcha": {
                                    return !this.form[name] ? "Veuillez cocher le captcha" : null;
                                }
                            }
                        }));
                    if (errors && errors.length) {
                        this.errors[name] = errors;
                        return false;
                    } else {
                        this.errors[name] = null;
                        return true;
                    }
                }
                return true;
            },
            _resetForm() {
                this._getFormInput("typeDeRequete").val("");
                this.form["typeDeRequete"] = "";
                this._getFormInput("typeUtilisateur2").val("");
                this.form["typeUtilisateur2"] = "";
                this.errors = {};
            },
            _resetFormTypeDeRequete() {
                this._getFormInput("typeUtilisateur2").val("");
                this.form["typeUtilisateur2"] = "";

                this.errors = {};
            },
            _getFormInputFile() {
                const $form = this._getForm(formIds[this.form.typeUtilisateur1]);
                if ($form.length) {
                    return $form.find('input[type="file"]');
                }
            },
            _getFormCheckboxFile(index) {
              const $form = this._getForm(formIds[this.form.typeUtilisateur1]);
                if ($form.length) {
                    return $form.find('.js-form-type-webform-document-file').find('input[type="checkbox"]')[index];
                }
            },
            _getFormListFilesUploaded() {
                const $form = this._getForm(formIds[this.form.typeUtilisateur1]);
                if ($form.length) {
                    return $form.find('.js-form-type-webform-document-file').find('label.option');
                }
            },
            _getFormInput(key, scoped) {
                if ( scoped ) {
                    const $form = this._getForm(formIds[this.form.typeUtilisateur1]);
                    if ($form.length) {
                        return $form.find(`[data-drupal-selector='edit-${key.toLowerCase()}']`);
                    }
                }
                return $(this.$el).find(`[data-drupal-selector='edit-${key.toLowerCase()}']`);
            },
            _getForm(key) {
                return $(this.$el).find(`[data-drupal-selector='webform-submission-${key}-node-76-add-form']`);
            },
            _validateEmail(email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            _validateAlpha(string) {
                var re = /^[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\s]*$/;
                return re.test(String(string).toLowerCase());
            },
            _validateName(string) {
                var re = /^[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\-'\s]*$/;
                return re.test(String(string).toLowerCase());
            },
            _validateLastnameFirstname(string) {
                var re = /([a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\-']{2,})([ ]{1,})([a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ\-']{2,})/;
                return re.test(String(string).toLowerCase());
            },
             _validateNumber(string) {
                var re = /^[\d]*$/;
                return re.test(String(string).toLowerCase());
            },
             _validatePhoneNumber(string) {
                var re = /^(\d{2} ){4}\d{2}$/;
                return re.test(String(string).toLowerCase());
            },
             _validateFiness(string) {
                var re = /^(\d{2} )(\d{3} ){2}\d{1}$/;
                return re.test(String(string).toLowerCase());
            },
             _validateZipcode(string) {
                var re = /^[\d]{5}$/;
                return re.test(String(string).toLowerCase());
            },
             _validateSiret(string) {
                var re = /^(\d{3} ){3}\d{5}$/;
                return re.test(String(string).toLowerCase());
            },
            toggleItem($event) {
                let $item = $($event.target).parent();
                $(".node-contact__map__place").not($item).removeClass("open");
                $item.toggleClass("open");
            }
        },
        computed: {
            posted: function () {
                return ( $("#edit-firstname").length === 0 );
            }
        }

    }

</script>
